import { InjectionToken } from '@angular/core';

export const API_BASE = new InjectionToken<string>('api.base.url');
